import * as React from 'react';
import { css } from 'styled-components';
import { NextArrow } from './next-arrow';
import { PrevArrow } from './prev-arrow';
import { ICarouselNavigationProps } from '../navigation';

interface IArrowNavigationProps extends Omit<ICarouselNavigationProps, 'type' | 'activeKey'>, Pick<React.HTMLProps<SVGSVGElement>, 'onClick'> {
}

export interface IArrowProps extends Pick<IArrowNavigationProps, 'onClick'> {
    $disabled?: boolean;
    $isHorizontal?: boolean;
    $indicatorPosition?: 'left' | 'right';
}

export const arrowContainerStyle = css<IArrowProps>`
    position: absolute;
    width: 90px;
    visibility: visible;
    height: ${({ $isHorizontal }) => ($isHorizontal ? '100%' : '50%')};
    left: ${({ $indicatorPosition, $isHorizontal }) => ($indicatorPosition === 'left' || $isHorizontal ? 0 : 'unset')};
    right: ${({ $indicatorPosition }) => ($indicatorPosition === 'right' ? 0 : 'unset')};
`;

export const arrowStyle = css<IArrowProps>`
    position: absolute;
    fill: ${({ theme: { carousel: { colors } } }) => colors.arrowNavigationColor};
    transition: fill 750ms linear;
    opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    transform: ${({ $isHorizontal }) => ($isHorizontal ? '' : 'rotate(90deg)')};
    :hover {
        fill: ${({ theme: { carousel: { colors } }, $disabled }) => (!$disabled && colors.arrowNavigationColorOnHover)};
    }
`;

export function ArrowNavigation(props: IArrowNavigationProps) {
    const { isHorizontal, itemsIterator, loop, indicatorPosition } = props;
    const isNextArrowDisabled = !loop && itemsIterator.getcurrentIndex() === itemsIterator.getLength() - 1;
    const isPrevArrowDisabled = !loop && itemsIterator.getcurrentIndex() === 0;

    const onNextArrowClick = React.useCallback(() => {
        itemsIterator.next();
    }, [itemsIterator]);

    const onPrevArrowClick = React.useCallback(() => {
        itemsIterator.prev();
    }, [itemsIterator]);

    return (
        <>
            <NextArrow
                $disabled={isNextArrowDisabled}
                $isHorizontal={isHorizontal}
                onClick={onNextArrowClick}
                $indicatorPosition={indicatorPosition} />
            <PrevArrow
                $disabled={isPrevArrowDisabled}
                $isHorizontal={isHorizontal}
                onClick={onPrevArrowClick}
                $indicatorPosition={indicatorPosition} />
        </>
    );
}
